<template>
    <div>
        <div class="wrap">
            <div class="wrap_bjt"></div>
            img
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    props:{
      query:{
        type:Number,
        default: 0,
      }
   },
   created() {
    console.log('gs333333======', this.query)
   }
}
</script>
<style scoped lang="scss">
.wrap {
  background: #ffffff;
  margin: 20px 20px 20px 20px;
  float: left;
  // padding: 0px 24px;
  width: 880px;
  height: 753px;
  .wrap_bjt {
    width: 880px;
    height: 270px;
    background: url(../images/wczy_tjb.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
  }
}
</style>